<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="60%"
    @close="closeDialog"
    :close-on-click-modal="false"
  >
    <div class="edit-container">
      <!-- 动态只读信息区域 -->
      <el-descriptions
        :column="2"
        size="medium"
        border
        v-if="readOnlyFields && readOnlyFields.length"
      >
        <el-descriptions-item
          v-for="field in readOnlyFields"
          :key="field.prop"
          :label="field.label"
        >
          {{ currentRow[field.prop] }}
        </el-descriptions-item>
      </el-descriptions>
      <!-- <div class="info-section" v-if="readOnlyFields && readOnlyFields.length">
        <div
          class="info-item"
          v-for="field in readOnlyFields"
          :key="field.prop"
        >
          <span class="label">{{ field.label }}</span>
          <span class="value">{{ currentRow[field.prop] }}</span>
        </div>
      </div> -->

      <!-- 动态可编辑表单区域 -->
      <div style="margin-top: 20px">
        <el-form
          :disabled="!isEdit"
          :model="form"
          :rules="rules"
          ref="editForm"
          v-if="editableFields && editableFields.length"
        >
          <el-form-item
            v-for="field in editableFields"
            :key="field.prop"
            :label="field.label"
            :prop="field.prop"
          >
            <el-input
              v-if="field.type == 'text'"
              v-model="form[field.prop]"
              :placeholder="field.placeholder || '请输入'"
              size="mdeium"
            >
              <template slot="append" v-if="field.unit">{{
                field.unit
              }}</template>
            </el-input>

            <el-input
              v-else
              type="number"
              size="mdeium"
              v-model="form[field.prop]"
              :placeholder="field.placeholder || '请输入'"
              :min="0"
            >
              <template slot="append" v-if="field.unit">{{
                field.unit
              }}</template>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog" size="medium">取消</el-button>
      <el-button v-if="isEdit" type="primary" @click="handleSubmit" size="medium"
        >确认</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "EditDialog",
  props: {
    // 表单是否可编辑
    isEdit:{
      type: Boolean,
      default: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "编辑",
    },
    currentRow: {
      type: Object,
      default: () => ({}),
    },
    // 只读区域字段配置
    readOnlyFields: {
      type: Array,
      default: () => [
        // 示例配置
        { label: "一级部门", prop: "department" },
        { label: "岗位", prop: "position" },
        { label: "姓名", prop: "name" },
      ],
    },
    // 可编辑区域字段配置
    editableFields: {
      type: Array,
      default: () => [
        // 示例配置
        {
          label: "实际完成",
          prop: "actualCompletion",
          placeholder: "请输入实际完成",
          required: true,
        },
        {
          label: "KPI得分",
          prop: "kpiScore",
          placeholder: "请输入KPI得分",
          required: true,
        },
      ],
    },
  },
  data() {
    return {
      form: {},
      rules: {},
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.initForm();
      }
    },
    currentRow: {
      immediate: true,
      handler() {
        this.initForm();
      },
    },
  },
  methods: {
    initForm() {
      // 初始化表单数据
      const formData = {};
      this.editableFields.forEach((field) => {
        formData[field.prop] = this.currentRow[field.prop] || "";
      });
      // 清除之前的验证状态
      this.$nextTick(() => {
        this.$refs.editForm && this.$refs.editForm.clearValidate();
      });
      this.form = formData;
      this.generateRules();
    },
    generateRules() {
      // 动态生成验证规则
      const rules = {};
      this.editableFields.forEach((field) => {
        if (field.required) {
          rules[field.prop] = [
            {
              required: true,
              message: `请输入${field.label}`,
              trigger: "blur",
            },
          ];
        }
      });
      this.rules = rules;
    },
    handleSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          // 表单验证通过，提交数据
          this.$emit("submit", {
            ...this.currentRow,
            ...this.form,
          });
          this.closeDialog();
        }
      });
    },
    closeDialog() {
      this.$refs.editForm.resetFields();
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
/* 保持原有样式不变 */
.edit-container {
  padding: 10px 0;
  font-size: 28px;
}

.info-section {
  margin-bottom: 20px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  padding: 16px 0;
  border-bottom: 1px dashed #f0f0f0;
}

.label {
  flex: 0 0 250px;
  color: #606266;
  text-align: left;
  padding-right: 16px;
}

.value {
  margin-left: 40px;
  flex: 1;
  color: #303133;
  word-break: break-all;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  padding: 15px 0 20px;
}

.el-button--primary {
  background-color: #008755;
  border-color: #008755;
}

.el-button--primary:hover {
  background-color: #008755;
  border-color: #008755;
}

::v-deep .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}
::v-deep .el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
</style>
